import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { Block } from '@haldor/ui';
import WizardTimeLine from './WizardTimeLine';

var Wizard = /*#__PURE__*/function (_Component) {
  _inherits(Wizard, _Component);

  var _super = _createSuper(Wizard);

  function Wizard() {
    var _this;

    _classCallCheck(this, Wizard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", function (nextProps) {
      if (_this.props.currentPage != nextProps.currentPage) {
        window.scrollTo(0, 0);
      }
    });

    return _this;
  }

  _createClass(Wizard, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      if (this.props.children == null) {
        return null;
      }

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(WizardTimeLine, {
        children: this.props.children,
        goToPage: function goToPage(i) {
          return _this2.props.disableWizardStepNavigation ? null : _this2.props.goToPage(i);
        },
        currentPage: this.props.currentPage
      }), /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement("div", null, this.props.children[this.props.currentPage])));
    }
  }]);

  return Wizard;
}(Component);

export default Wizard;